module.exports = __webpack_public_path__ + "img/state1.9735a877.webp";